<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Customer default prices</h4>
    </div>
    <form @submit.prevent="submitForm()">
      <v-alert type="success" :value="successAlert">
        Customer Prices updated successfully
      </v-alert>
      <v-alert type="error" :value="errorAlert">
        Please update anything
      </v-alert>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm12 md5>
            <v-text-field
              style="width: 90%"
              label="Price per weight (USA)*"
              :error-messages="errors.collect('Price per weight (USA)')"
              v-validate="'required|decimal:2'"
              data-vv-name="Price per weight (USA)"
              v-model.number="defaultPriceData.customer_price_per_weight_usa"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm12 md5>
            <v-text-field
              style="width: 90%"
              label="Price per weight (Turkey)*"
              :error-messages="errors.collect('Price per weight (Turkey)')"
              v-validate="'required|decimal:2'"
              data-vv-name="Price per weight (Turkey)"
              v-model.number="defaultPriceData.customer_price_per_weight_turkey"
            ></v-text-field> -->
          </v-flex>
          <v-flex xs12 sm12 md5>
            <v-text-field
              style="width: 90%"
              label="Base Qtt charge (USA)*"
              :error-messages="errors.collect('Base Qtt charge (USA)')"
              v-validate="'required|decimal:2'"
              data-vv-name="Base Qtt charge (USA)"
              v-model.number="defaultPriceData.customer_base_qtt_charge_usa"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm12 md5>
            <v-text-field
              style="width: 90%"
              label="Base Qtt charge (Turkey)*"
              :error-messages="errors.collect('Base Qtt charge (Turkey)')"
              v-validate="'required|decimal:2'"
              data-vv-name="Base Qtt charge (Turkey)"
              v-model.number="defaultPriceData.customer_base_qtt_charge_turkey"
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12 sm12 md5>
            <v-text-field
              style="width: 90%"
              label="Other Qtt charge (USA)*"
              :error-messages="errors.collect('Other Qtt charge (USA)')"
              v-validate="'required|decimal:2'"
              data-vv-name="Other Qtt charge (USA)"
              v-model.number="defaultPriceData.customer_other_qtt_charge_usa"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm12 md5>
            <v-text-field
              style="width: 90%"
              label="Other Qtt charge (Turkey)*"
              :error-messages="errors.collect('Other Qtt charge (Turkey)')"
              v-validate="'required|decimal:2'"
              data-vv-name="Other Qtt charge (Turkey)"
              v-model.number="defaultPriceData.customer_other_qtt_charge_turkey"
            ></v-text-field>
          </v-flex> -->
        </v-layout>
      </v-container>
      <v-spacer></v-spacer>
      <v-flex xs12 sm12 md5>
        <v-btn type="submit" style="width: 95%; height:auto; margin-bottom: 3%" color="success"
          >Save</v-btn
        >
      </v-flex>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  created() {
    let thePanel = document.querySelector('.panel-flat')
    thePanel.style.overflowX = 'hidden'
  },

  mounted() {
    this.getDefaultPrices()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      getDefaultPriceUrl: 'api/default_price',
      successAlert: false,
      errorAlert: false,
      defaultPriceData: {
        customer_price_per_weight_usa: 0,
        customer_price_per_weight_turkey: 0,
        customer_base_qtt_charge_turkey: 0,
        customer_base_qtt_charge_usa: 0,
        customer_other_qtt_charge_turkey: 0,
        customer_other_qtt_charge_usa: 0
      },
      updateDefaultPriceData: {
        customer_price_per_weight_usa: 0,
        customer_price_per_weight_turkey: 0,
        customer_base_qtt_charge_turkey: 0,
        customer_base_qtt_charge_usa: 0,
        customer_other_qtt_charge_turkey: 0,
        customer_other_qtt_charge_usa: 0
      }
    }
  },

  methods: {
    getDefaultPrices() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getDefaultPriceUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data.data

          this.defaultPriceData.customer_base_qtt_charge_turkey =
            result[0].customer_base_qtt_charge_turkey
          this.defaultPriceData.customer_base_qtt_charge_usa =
            result[0].customer_base_qtt_charge_usa
          this.defaultPriceData.customer_other_qtt_charge_turkey =
            result[0].customer_other_qtt_charge_turkey
          this.defaultPriceData.customer_other_qtt_charge_usa =
            result[0].customer_other_qtt_charge_usa
          this.defaultPriceData.customer_price_per_weight_turkey =
            result[0].customer_price_per_weight_turkey
          this.defaultPriceData.customer_price_per_weight_usa =
            result[0].customer_price_per_weight_usa
        })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.updateDefaultPriceData.customer_price_per_weight_usa = this.defaultPriceData.customer_price_per_weight_usa
          this.updateDefaultPriceData.customer_price_per_weight_turkey = this.defaultPriceData.customer_price_per_weight_turkey
          this.updateDefaultPriceData.customer_base_qtt_charge_turkey = this.defaultPriceData.customer_base_qtt_charge_turkey
          this.updateDefaultPriceData.customer_base_qtt_charge_usa = this.defaultPriceData.customer_base_qtt_charge_usa
          this.updateDefaultPriceData.customer_other_qtt_charge_turkey = this.defaultPriceData.customer_other_qtt_charge_turkey
          this.updateDefaultPriceData.customer_other_qtt_charge_usa = this.defaultPriceData.customer_other_qtt_charge_usa

          let token = localStorage.getItem('access_token')

          axios
            .put(this.getDefaultPriceUrl + '/' + 1, this.updateDefaultPriceData, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.errorAlert = false
              this.successAlert = true

              let self = this
              setTimeout(() => {
                self.successAlert = false
              }, 2000)
            })
            .catch(() => {
              this.successAlert = false
              this.errorAlert = true

              let self = this
              setTimeout(() => {
                self.errorAlert = false
              }, 2000)
            })
        }
      })
    }
  }
}
</script>

<style scoped>


.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/customerPrices.vue